import { render, staticRenderFns } from "./addItem.vue?vue&type=template&id=546eac83&scoped=true&"
import script from "./addItem.vue?vue&type=script&lang=js&"
export * from "./addItem.vue?vue&type=script&lang=js&"
import style0 from "./addItem.vue?vue&type=style&index=0&id=546eac83&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546eac83",
  null
  
)

export default component.exports